// extracted by mini-css-extract-plugin
export default {"wrapper":"MultipleCustomOption_wrapper__DbK+t","selected":"MultipleCustomOption_selected__RB1bZ","half-selected":"MultipleCustomOption_half-selected__uTB1S"};